const { findWarehouseByLocationId, getFunderWarehouseId } = require('../../order/tools/read/warehouse-code-to-virtual')

// Helpers for the LMD Source filter (issue #23868), built on the canonical
// warehouse id tooling in order/tools/read/warehouse-code-to-virtual.js:
// funder-split virtual warehouses share one real (physical) warehouse and
// carry its id plus a funder suffix (e.g. 'zone:south-south:name:calabar-pmi'
// is the 'funder:pmi' copy of 'zone:south-south:name:calabar'). The Source
// filter lists only the real warehouses; the selected warehouse is expanded
// server-side to the virtual copies the requesting user's funders give
// access to.

// Ids that don't resolve to a hard-coded warehouse definition (e.g. tenants
// without funder-split warehouses) are kept as sent. `findWarehouseByLocationId`
// returns null (rather than throwing) for these, so an unresolved id is an
// explicit branch and genuine lookup errors are not swallowed.
const toRealWarehouseId = (originId) => {
  const match = findWarehouseByLocationId(originId, null)
  return match ? match._id : originId
}

// Collapse shipment origin ids onto their real warehouse ids so the Source
// filter lists each physical warehouse once.
const collapseOriginsToRealWarehouses = (originIds) => {
  const realIds = new Set(originIds.filter(Boolean).map(toRealWarehouseId))
  return [...realIds]
}

// Counterpart of collapseOriginsToRealWarehouses: turn the selected source
// into the funder-split virtual warehouse ids the user can access. Users
// without funders keep the real warehouse id, which the query
// substring-matches, so it covers the real warehouse and all of its virtual
// copies. The source is resolved to its real warehouse first, so virtual ids
// sent directly (e.g. from an old bookmarked URL) are never double-suffixed.
//
// Funder suffixes are only appended when the origin resolves to a hard-coded
// (funder-split) warehouse. An origin with no such definition has no
// funder-split copies in the DB, so a `<id>-<funder>` suffix would match
// nothing; those keep the raw real id regardless of funders, letting the
// substring match cover the warehouse and any copies.
const expandOriginWarehousesByFunders = (originId, funders = []) => {
  const origins = (Array.isArray(originId) ? originId : [originId]).filter(Boolean)
  const funderIds = funders.filter(Boolean)
  if (origins.length === 0) {
    return originId
  }

  const expanded = new Set()
  origins.forEach(origin => {
    const match = findWarehouseByLocationId(origin, null)
    const realId = match ? match._id : origin
    if (funderIds.length === 0 || !match) {
      expanded.add(realId)
      return
    }
    funderIds.forEach(funderId => {
      expanded.add(getFunderWarehouseId({ locationId: realId, funderId }))
    })
  })

  const result = [...expanded]
  return result.length === 1 ? result[0] : result
}

module.exports = {
  collapseOriginsToRealWarehouses,
  expandOriginWarehousesByFunders
}
